export default {"src":"/_next/static/media/TryOnHandIcon.50106188.svg","height":15,"width":18};